import axios, { AxiosResponse } from "axios";
import {IReturnedNotification} from "./returned-notifications.type";

/**
 * Получение данных из сервиса Взимание по ИИН/БИН
 */
export const getReturnedNotifications = (data: any): Promise<AxiosResponse<IReturnedNotification[]>> => {
  return axios.get(`/services/isnaportalsync/open-api/returned-notifications`, {
    params: {
      ...data,
    }
  });
};
